"use client";

import Link from "next/link";
import { MoveLeft } from "lucide-react";
import { Button } from "./ui/button";
import CardImage from "./ui/CardImage";
import { getBrandHref } from "@/lib/navigation/brand";

const BrandCard = ({ brand, priority = false }) => {
  const title = brand.title || brand.name;

  return (
    <div className="w-[320px] lg:w-[395px] rounded-3xl p-4 pb-6 lg:p-6 lg:pb-8 glass-box relative mx-auto flex flex-col h-full">
      <div className="relative w-full flex justify-center flex-shrink-0">
        <CardImage src={brand.logo || null} alt={title} priority={priority} />
      </div>

      <div className="w-full flex flex-col justify-between gap-2 lg:mt-5 flex-1">
        <div>
          <h3 className="text-base lg:text-lg font-semibold mb-1 lg:mb-3 line-clamp-1">
            {title}
          </h3>
          <div className="text-mute text-sm line-clamp-3 mt-4 h-[60px]">
            {brand.description || ""}
          </div>
        </div>

        <div className="flex justify-between items-end">
          <Link href={brand.href || getBrandHref(brand) || `/product?brandIds=${brand.id}`}>
            <Button className="justify-between w-fit font-semibold" variant="whiteBorder" size="lg">
              مشاهده محصولات
              <MoveLeft className="text-white" />
            </Button>
          </Link>

        </div>
      </div>
    </div>
  );
};

export default BrandCard;
